/* Kinegun PDP: shared tabs, navigation, comparisons and editor lifecycle. */
(() => {
  'use strict';
  if (window.KinegunPDP) {
    window.KinegunPDP.init(document);
    return;
  }
  const selector = '[data-kg-pdp]';
  const states = new WeakMap();

  function rootsIn(context) {
    const roots = [...context.querySelectorAll(selector)];
    if (context.matches?.(selector)) roots.unshift(context);
    return roots;
  }


  function syncNavigation() {
    document.querySelectorAll(selector + ' [data-pdp-nav]').forEach(link => {
      link.hidden = !document.getElementById(link.hash.slice(1));
    });
  }

  function init(context) {
    rootsIn(context).forEach(root => {
      if (states.has(root)) return;
      const controller = new AbortController();
      const signal = controller.signal;
      const state = { controller };
      states.set(root, state);
      const tabs = [...root.querySelectorAll('[data-benefit]')];
      const panels = [...root.querySelectorAll('[data-benefit-panel]')];
      state.showBenefit = (tab, focus = false) => {
        if (!tab) return;
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.benefitPanel !== tab.dataset.benefit; });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => state.showBenefit(tab), { signal });
        tab.addEventListener('keydown', event => {
          const next = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
          if (next !== undefined) { event.preventDefault(); state.showBenefit(tabs[next], true); }
        }, { signal });
      });
      if (tabs.length) { root.querySelector('.benefit-tabs').dataset.enhanced = ''; state.showBenefit(tabs[0]); }
      const compare = root.querySelector('.cmp-section');
      if (compare) {
        compare.dataset.enhanced = '';
        const switcher = root.querySelector('.cmp-switch');
        if (switcher) switcher.dataset.enhanced = '';
        const buttons = [...root.querySelectorAll('[data-compare-model]')];
        buttons.forEach(button => button.addEventListener('click', () => {
          compare.dataset.compare = button.dataset.compareModel;
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        }, { signal }));
      }
    });
    syncNavigation();
  }

  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-pdp-mode-target]');
    if (!link?.closest(selector)) return;
    const value = Number(link.dataset.pdpModeTarget);
    if ([0, 1, 8].includes(value)) document.dispatchEvent(new CustomEvent('kg:pdp:mode', { detail: { simulator: 'go', value } }));
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    rootsIn(event.target).forEach(root => {
      const state = states.get(root);
      state?.controller.abort(); states.delete(root);
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest?.('[data-block-id]') || document.querySelector(selector + ' [data-block-id="' + CSS.escape(event.detail.blockId) + '"]');
    const root = item?.closest(selector);
    if (!root) return;
    if (item.dataset.benefitPanel) {
      const tab = [...root.querySelectorAll('[data-benefit]')].find(t => t.dataset.benefit === item.dataset.benefitPanel);
      states.get(root)?.showBenefit(tab);
    }
    if (item.tagName === 'DETAILS') item.open = true;
  });
  window.KinegunPDP = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
